import { GrayBackground, Image, soundManager, useVoucherStore } from '@slot-nx/core'
import { memo, useEffect, useRef } from 'react'
import { Container } from '@pixi/react'
import { VoucherTotalWinTitle } from './VoucherTotalWinTitle'
import { VoucherTotalWinContent } from './VoucherTotalWinContent'
import { Container as PixiContainer } from 'pixi.js'
import { showPopupAnimation } from '../selectPopup/VoucherSelectPopup'
import { VoucherTotalWinButton } from './VoucherTotalWinButton'
import { VoucherSoundType } from '../../../domain/soundManager/enum/VoucherSoundType'

export const VoucherTotalWinPopup = memo(() => {
  const isShow = useVoucherStore(x => x.isShowVoucherTotalWinPopup)
  const [totalPayout] = useVoucherStore(x => [x.totalPayout])
  const popupRef = useRef<PixiContainer>()
  useEffect(() => {
    if (isShow && popupRef.current) {
      soundManager.play(VoucherSoundType.totalWinPopup)
      showPopupAnimation(popupRef.current)
    }
  }, [isShow])
  return (
    <Container name="VoucherTotalWinWrapper" visible={isShow}>
      <GrayBackground name="VoucherPopup_Bg">
        <Container name="VoucherTotalWinPopup" x={540} y={960} ref={(el) => { popupRef.current = el as PixiContainer }}>
          <Image name="voucher_total_win"image="voucher_Total_Win"width={942}height={1136}anchor={[0.5, 0.5]}x={0}y={-130} />
          <VoucherTotalWinTitle />
          <VoucherTotalWinContent totalPayout={totalPayout} />
          <VoucherTotalWinButton />
        </Container>
      </GrayBackground>
    </Container>

  )
})
